import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextSize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTextSize"><Path d="M23 4H9V5.5H15.25V21H16.75V5.5H23V4Z" fill="currentColor"/><Path d="M7.67676 21V11.75H13V10.25H1V11.75H6.17676V21H7.67676Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextSize;
